import { CircularProgress } from "@mui/material";

export const CustomCircularProgress = ({ ...props }) => {
  return <CircularProgress size={18} thickness={4} {...props} value={100} />;
};
